
namespace Gamification.Gamification {

    @Serenity.Decorators.registerFormatter()
    export class SlickGridPercentageFormatter implements Slick.Formatter {

        @Serenity.Decorators.option()
        public cultureName: string;

        @Serenity.Decorators.option()
        public decimalPlaces: number;

        format(ctx: Slick.FormatterContext) {

            if (!Q.isValue(ctx.value)) {
                ctx.value = 0;
            }

            this.cultureName = Q.coalesce(this.cultureName, 'en-NZ');
            this.decimalPlaces = Q.coalesce(this.decimalPlaces, 2);

            var formatter = new Intl.NumberFormat(this.cultureName, {
                style: 'percent',
                minimumFractionDigits: this.decimalPlaces,
            });

            //use the above formatter to return the reformatted value
            var percentValue = formatter.format(Number(ctx.value));
            return percentValue;
        }
    }
}